import "./App.css";
import { Routes, Route, Navigate, useNavigate, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import Login from "./pages/login/login";
import EmployeeMaster from "./pages/EmployeeMaster/EmployeeMaster";
import DepartmentMaster from "./pages/DepartmentMaster/DepartmentMaster";
import DesignationMaster from "./pages/DesignationMaster/DesignationMaster";
import PetTypeMaster from "./pages/PetTypeMaster/PetTypeMaster";
import PetBreedMaster from "./pages/PetBreedMaster/PetBreedMaster";
import CountryMaster from "./pages/CountryMaster/CountryMaster";
import RegionMaster from "./pages/RegionMaster/RegionMaster";
import StateMaster from "./pages/StateMaster/StateMaster";
import CityMaster from "./pages/CityMaster/CityMaster";
import StatusMaster from "./pages/StatusMaster/StatusMaster";
import StagesMaster from "./pages/StagesMaster/StagesMaster";
import LeadSourceMaster from "./pages/LeadSourceMaster/LeadSourceMaster";
import ChargesMaster from "./pages/ChargesMaster/ChargesMaster";
import PetCrateMaster from "./pages/PetCrateMaster/PetCrateMaster";
import MicrochipMaster from "./pages/MicrochipMaster/MicrochipMaster";
import PetCrateQuantityMaster from "./pages/PetCrateQuantityMaster/PetCrateQuantityMaster";
import PetMicrochipQuantityMaster from "./pages/PetMicrochipQuantityMaster/PetMicrochipQuantityMaster";
import SupplierMaster from "./pages/SupplierMaster/SupplierMaster";
import Dashboard from "./pages/SalesMasterPages/Dashboard/Dashboard";
import LeadList from "./pages/SalesMasterPages/LeadList/LeadList";
import AddLead from "./pages/SalesMasterPages/AddLead/AddLead";

import TrainApiTest from "./pages/SalesMasterPages/TrainApiTest";
import PriceCalculator from "./pages/SalesMasterPages/PriceCalculator/PriceCalculator";
import StaffListMain from "./pages/SalesMasterPages/User/StaffListMain/StaffListMain";
import MRPSheet from "./pages/SalesMasterPages/MRPSheet/MRPSheet";
import SalesTarget from "./pages/SalesMasterPages/User/SalesTarget/MainPage/SalesTarget";
import SalesTargetPerUser from "./pages/SalesMasterPages/User/SalesTarget/SalesTargetPerUser/SalesTargetPerUser";
import QuotationBuilder from "./pages/SalesMasterPages/QuotationBuilder/QuotationBuilder";
import Estimate from "./pages/SalesMasterPages/Estimate/Estimate";
import ChangePassword from "./pages/ChangePassword/ChangePassword";
import UserAvailability from "./pages/SalesMasterPages/User/CheckAvailability/UserAvailability";
import AvailabilityView from "./pages/SalesMasterPages/User/CheckAvailability/AvailabilityView/AvailabilityView"
import UpdateLead from "./pages/SalesMasterPages/UpdateLead/UpdateLead";
import LeadDataReportMaster from "./pages/LeadDataReportMaster/LeadDataReportMaster";
import ViewLeadDetail from "./pages/SalesMasterPages/ViewLeadDetail/ViewLeadDetail";
import ViewLeadDetail_2pets from "./pages/SalesMasterPages/ViewLeadDetail/ViewLeadDetail_2pets";

import AirFrieghtDomesticMaster from "./pages/AirFrieghtDomesticMaster/AirFrieghtDomesticMaster";
import DomesticRelocationAir from "./pages/SalesMasterPages/DomesticRelocationAir/DomesticRelocationAir";
import DomesticRelocationTrain from "./pages/SalesMasterPages/DomesticRelocationTrain/DomesticRelocationTrain";
import DomesticRelocationRoad from "./pages/SalesMasterPages/DomesticRelocationRoad/DomesticRelocationRoad";
import OrderList from "./pages/OperationMasterPages/OrderList/OrderList";
import ViewOrderDetails from "./pages/OperationMasterPages/ViewOrderDetails/ViewOrderDetails";
import OrderData from "./pages/CustomerPannel/OrderData/OrderData";
import CustomerNavbar from "./components/CustomerNavar/CustomerNavbar";
import LoginCustomer from "./pages/CustomerPannel/Login/LoginCustomer";
import CreatePasssword from "./pages/CustomerPannel/Login/CreatePassword";
import ConvertedLeadDataReport from "./pages/OperationMasterPages/ConvertedLeadDataReport/ConvertedLeadDataReport";
import ExpenseList from "./pages/OperationMasterPages/ExpenseList/ExpenseList";
import LeadExpenseList from "./components/LeadExpenseList/LeadExpenseList";
import Petcratelists from "./components/Petcratelists/Petcratelists";
import PetcrateList from "./pages/OperationMasterPages/Inventory/PetcrateList";
import Microchip from "./components/Microchip/Microchip";
import MicrochipListMain from "./pages/OperationMasterPages/Inventory/MicrochipListMain";
import MicrochipQuantityMain from "./pages/OperationMasterPages/Inventory/MicrochipQuantityMain";
import LeadCount from "./pages/LeadCount/LeadCount";
import AddVendorDetails from "./components/AddVendorDetails/AddVendorDetails";
import AddVendorDetails_Admin from "./components/AddVendorDetails_Admin/AddVendorDetails_Admin";
import ChangeDOC from "./pages/ChangeDOC/ChangeDOC";
import OpsDashboard from "./pages/SalesMasterPages/DashboardTest/DashboardTest";
import AddOpsExpense from "./components/AddOpsExpense/AddOpsExpense";
import FieldOpsExpenseList from "./components/FieldOpsExpenseList/FieldOpsExpenseList";
import InternationalRelocation from "./pages/SalesMasterPages/InternationalRelocation/InternationalRelocation";

import SalesOrder from "./pages/OperationMasterPages/SalesOrder/SalesOrder";
import StaffListMainOperation from "./pages/OperationMasterPages/StaffListMainOperation/StaffListMainOperation";
import UserAvailabilityOps from "./pages/OperationMasterPages/UsersAvailibiltyOps/UserAvailibiltyOps";
import ClientDocuments from "./pages/OperationMasterPages/ClientDocuments/ClientDocuments";
import DashboardOps from "./pages/OperationMasterPages/DashboardOps/DashboardOps";
import VendorDetailsOverview from "./components/VendorDetailsOverview/VendorDetailsOverview";
import Estimate1 from "./pages/SalesMasterPages/Estimate1/Estimate1";
import AssetsMaster from "./pages/AssestsMaster/AssetsMaster";
import LeadTransfer from "./pages/LeadTransfer/LeadTransfer";
import LeadDetail from "./pages/SalesMasterPages/ViewLeadDetails/LeadDetail";
import PettyCashList from "./pages/PettyCashList/PettyCashList";
import ViewPettyCashDetail from "./pages/ViewPettyCashDetail/ViewPettyCashDetail";
import PettyCashDetail from "./pages/ViewPettyCashDetail/PettyCashDetail";
import Test from "./pages/Test";

import PaymentSuccess from "./pages/OtherPages/paymentSuccess";
import PaymentFailed from "./pages/OtherPages/paymentFailed";


import PaymentConfirmation from "./pages/AccountsMasterPages/PaymentConfirmation/PaymentConfirmation";
import ShipmentList from "./pages/AccountsMasterPages/ShipmentList/ShipmentList";
import ViewShipmentListDetail from "./pages/AccountsMasterPages/ViewShipmentListDetail/ViewShipmentListDetail";
import AccountsInvoice from "./pages/AccountsMasterPages/AccountsInvoice/AccountsInvoice";
import ShipmentExecutionSheet from "./pages/AccountsMasterPages/ShipmentExecutionSheet/ShipmentExecutionSheet";
import PaymentReceipt from "./pages/AccountsMasterPages/PaymentReceipt/PaymentReceipt";
import ProfitAndLoss from "./pages/AccountsMasterPages/ProfitAndLoss/ProfitAndLoss";
import ProfitLossReport from "./pages/AccountsMasterPages/ProfitLossReport/ProfitLossReport";
import CustomerBalance from "./pages/AccountsMasterPages/CustomerBalance/CustomerBalance";
import EmployeeExpenseDetail from "./pages/AccountsMasterPages/EmployeeExpenseDetail/EmployeeExpenseDetail";
import EmployeeExpenseDetailList from "./pages/AccountsMasterPages/EmployeeExpenseDetail/EmployeeExpenseDetailList";
import PettyCashStatement from "./pages/PettyCashStatement/PettyCashStatement.js";
import BalanceSheet from "./pages/AccountsMasterPages/BalanceSheet/BalanceSheet";
import PaymentReceiptInfo from "./pages/SalesMasterPages/PaymentReceiptInfo/PaymentReceiptInfo";
import AccountsBills from "../src/components/AccountsBills/bills"
import PettyCashHistorylist from "./pages/PettyCashHistorylist/PettyCashHistorylist";
import RelocationExpenseDetail from "./pages/OperationMasterPages/RelocationExpenseDetail/RelocationExpenseDetail";
import TiterForm from "./components/TiterForm/titer"
import Biobest from "./components/BioBest/bioBest"
import RffitLaboratoriesFrom from "./components/RffitLaboratoriesFrom/RffitLaboratoriesFrom"
import UpdateExpenseDetails from "./pages/UpdateExpenseDetails/UpdateExpenseDetails.js";
import AccountsDashboard from "./pages/AccountsMasterPages/AccountsDashboard/AccountsDashboard";

import CostCenterMaster from "./pages/CostCenterMaster/CostCenterMaster.js";
import SubCostCenterMaster from "./pages/SubCostCenterMaster/SubCostCenterMaster.js";
import ExpenseCategory from "./pages/ExpenseCategory/ExpenseCategory.js";
import ExpenseDescription from "./pages/ExpenseDescription/ExpenseDescription.js";
import TaskAssigned from "./pages/TaskAssignedMaster/TaskAssigned.js";
import ViewTaskAssignedDetail from "./pages/ViewTaskAssignedDetail/ViewTaskAssignedDetail.js";
import RateCalculatorIndia from "./pages/SalesMasterPages/PriceCalculator/RateCalculatorIndia.jsx";
import EstimateIn from "./pages/SalesMasterPages/EstimateIndia/EstimateIndia.jsx";
import DuttySlipBook from "./pages/DutySlipBook/DutySlip.js"
import DutySlipDetails from "./pages/DutySlipDetails/DutySlipDetails.jsx"
import CheckHistory from "./components/CheckHistory/Checkhistory.jsx"
import CheckHistoryDetails from "./components/CheckHistoryDetail/CheckHistoryDetail.jsx"
import EstimateList from "./pages/EstimateList/EstimateList.jsx";
import Ratesheet from "./pages/RateSheet/RateSheet";
import SalesSummary from "./components/SalesSummary/SalesSummary.js"
import AccountsExpense from "./components/AccountsExpense/AccountsExpense.jsx";
import PaymentReceipt1 from "./components/PaymentReceipt/PaymentReceipt.jsx";
import FieldMiniDrawer from "./components/FieldOperationsMiniDrawerMobile/fieldminiDrawer.jsx";
import PettyCashScreen from "./pages/FieldOperationsMobile/PettyCash.jsx";
import PettyCashRequest from "./pages/FieldOperationsMobile/PettyCashRequest/PettyCashRequest.jsx";
import PettyCashExpense from "./pages/FieldOperationsMobile/PettyCashExpense/PettyCashExpense.jsx"
import TripHistory from "./pages/FieldOperationsMobile/TripHistory/TripHistory.jsx";
import TripDetail from "./components/FieldOperationsMiniDrawerMobile/TripDetail/TripDetail.jsx";
import FieldDutySlip from "./pages/FieldOperationsMobile/DutySlip/DutySlip.jsx";
import FieldDutySlipDetail from "./pages/FieldOperationsMobile/DutySlipDetail/DutySlipDetail.jsx";
import ExpenseReport from "./pages/AccountsMasterPages/ExpenseReport/ExpenseReport.jsx";
import IndirectExpense from "./pages/AccountsMasterPages/IndirectExpense/IndirectExpense.jsx";



const ProtectedRoute = ({ children, allowedModules }) => {
  const isAuthenticated = localStorage.getItem('token'); // Adjust based on how you're storing the token

  if (!isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  // Check if the user has access to any of the allowed modules
  const hasAccess = allowedModules.some(module => localStorage.getItem(`is_${module}`) === 'true');

  if (!hasAccess) {
    return <Navigate to="/" replace />; // Replace with your unauthorized access page
  }

  return children;
};


function App() {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {

    const publicPaths = ["/AddVendorDetails", "/LeadDetail", "/CreatePasssword", "/Login-Customer", "/Test", "/PaymentSuccess", "/PaymentFailed", "/PaymentConfirmation", "/titer-form", "/bioBest", "/RffitLaboratories"];
    const currentPath = location.pathname;

    // ✅ Skip token check for public routes
    if (publicPaths.includes(currentPath)) return;


    const accessToken = localStorage.getItem('token');
    const tokenExpiration = localStorage.getItem('tokenExpiration');

    if (accessToken && tokenExpiration) {
      const currentTime = Date.now();
      const expirationTime = new Date(tokenExpiration).getTime();

      if (currentTime < expirationTime) {
        setIsLoggedIn(true);

      } else {
        localStorage.clear();
        window.location.reload();
        navigate("/");
      }
    } else {
      navigate("/");
    }
  }, []);



  return (
    <>
      <Routes>
        {/* Masters */}
        <Route path="/" name="Login Page" element={<Login />} />
        <Route path="/EmployeeMaster" name="EmployeeMaster" element={<ProtectedRoute allowedModules={["master", "HR"]}><EmployeeMaster /></ProtectedRoute>} />
        <Route path="/DepartmentMaster" element={<ProtectedRoute allowedModules={['master']}><DepartmentMaster /></ProtectedRoute>} />
        <Route path="/DesignationMaster" element={<ProtectedRoute allowedModules={['master']}><DesignationMaster /></ProtectedRoute>} />
        <Route path="/PetTypeMaster" element={<ProtectedRoute allowedModules={['master']}><PetTypeMaster /></ProtectedRoute>} />
        <Route path="/PetBreedMaster" element={<ProtectedRoute allowedModules={['master']}><PetBreedMaster /></ProtectedRoute>} />
        <Route path="/CountryMaster" element={<ProtectedRoute allowedModules={['master']}><CountryMaster /></ProtectedRoute>} />
        <Route path="/RegionMaster" element={<ProtectedRoute allowedModules={['master']}><RegionMaster /></ProtectedRoute>} />
        <Route path="/StateMaster" element={<ProtectedRoute allowedModules={['master']}><StateMaster /></ProtectedRoute>} />
        <Route path="/CityMaster" element={<ProtectedRoute allowedModules={['master']}><CityMaster /></ProtectedRoute>} />
        <Route path="/StatusMaster" element={<ProtectedRoute allowedModules={['master']}><StatusMaster /></ProtectedRoute>} />
        <Route path="/StagesMaster" element={<ProtectedRoute allowedModules={['master']}><StagesMaster /></ProtectedRoute>} />
        <Route path="/LeadSourceMaster" element={<ProtectedRoute allowedModules={['master']}><LeadSourceMaster /></ProtectedRoute>} />
        <Route path="/ChargesMaster" element={<ProtectedRoute allowedModules={['master']}><ChargesMaster /></ProtectedRoute>} />
        <Route path="/PetCrateMaster" element={<ProtectedRoute allowedModules={['master']}><PetCrateMaster /></ProtectedRoute>} />
        <Route path="/MicrochipMaster" element={<ProtectedRoute allowedModules={['master']}><MicrochipMaster /></ProtectedRoute>} />
        <Route path="/PetCrateQuantityMaster" element={<ProtectedRoute allowedModules={['master']}><PetCrateQuantityMaster /></ProtectedRoute>} />
        <Route path="/PetMicrochipQuantityMaster" element={<ProtectedRoute allowedModules={['master']}><PetMicrochipQuantityMaster /></ProtectedRoute>} />
        <Route path="/SupplierMaster" element={<ProtectedRoute allowedModules={['master', 'account']}><SupplierMaster /></ProtectedRoute>} />
        <Route path="/Dashboard" element={<ProtectedRoute allowedModules={['sales']}><Dashboard /></ProtectedRoute>} />
        <Route path="/LeadList" element={<ProtectedRoute allowedModules={['sales']}><LeadList /></ProtectedRoute>} />
        <Route path="/AddLead" element={<ProtectedRoute allowedModules={['sales']}><AddLead /></ProtectedRoute>} />

        <Route path="/TrainApiTest" element={<ProtectedRoute allowedModules={['sales']}><TrainApiTest /></ProtectedRoute>} />
        <Route path="/PriceCalculator" element={<ProtectedRoute allowedModules={['sales']}><PriceCalculator /></ProtectedRoute>} />
        <Route path="/StaffListMain" element={<ProtectedRoute allowedModules={['sales']}><StaffListMain /></ProtectedRoute>} />
        <Route path="/MRPSheet" element={<ProtectedRoute allowedModules={['sales']}><MRPSheet /></ProtectedRoute>} />
        <Route path="/SalesTarget" element={<ProtectedRoute allowedModules={['sales']}><SalesTarget /></ProtectedRoute>} />
        <Route path="/SalesTargetPerUser" element={<ProtectedRoute allowedModules={['sales']}><SalesTargetPerUser /></ProtectedRoute>} />
        <Route path="/UserAvailability" element={<ProtectedRoute allowedModules={['sales']}><UserAvailability /></ProtectedRoute>} />
        <Route path="/AvailabilityView" element={<ProtectedRoute allowedModules={['sales']}><AvailabilityView /></ProtectedRoute>} />
        <Route path="/QuotationBuilder" element={<ProtectedRoute allowedModules={['sales']}><QuotationBuilder /></ProtectedRoute>} />
        <Route path="/LeadDataReportMaster" element={<ProtectedRoute allowedModules={['sales']}><LeadDataReportMaster /></ProtectedRoute>} />
        <Route path="/ViewLeadDetail" element={<ProtectedRoute allowedModules={['sales']}><ViewLeadDetail /></ProtectedRoute>} />
        <Route path="/ViewLeadDetail_2pets" element={<ProtectedRoute allowedModules={['sales']}><ViewLeadDetail_2pets /></ProtectedRoute>} />
        <Route path="/Estimate" element={<ProtectedRoute allowedModules={['sales']}><Estimate /></ProtectedRoute>} />
        <Route path="/Estimate1" element={<Estimate1 />} />
        <Route path="/ChangePassword" element={<ProtectedRoute allowedModules={['sales', 'master', 'account', 'operation', 'HR']}><ChangePassword /></ProtectedRoute>} />
        <Route path="/AirFrieghtDomesticMaster" element={<ProtectedRoute allowedModules={['master']}><AirFrieghtDomesticMaster /></ProtectedRoute>} />
        <Route path="/Estimate" element={<ProtectedRoute allowedModules={['sales']}><Estimate /></ProtectedRoute>} />
        <Route path="/domestic-relocation-air" element={<ProtectedRoute allowedModules={['sales']}> <DomesticRelocationAir /> </ProtectedRoute>} />
        <Route path="/domestic-relocation-train" element={<ProtectedRoute allowedModules={['sales']}> <DomesticRelocationTrain /> </ProtectedRoute>} />
        <Route path="/domestic-relocation-road" element={<ProtectedRoute allowedModules={['sales']}> <DomesticRelocationRoad /> </ProtectedRoute>} />
        <Route path="/Leadcount" element={<ProtectedRoute allowedModules={['sales']}><LeadCount /></ProtectedRoute>} />
        <Route path="/ChangeDOC" element={<ProtectedRoute allowedModules={['sales']}><ChangeDOC /></ProtectedRoute>} />
        <Route path="/OrderList" element={<ProtectedRoute allowedModules={['operation']}> <OrderList /> </ProtectedRoute>} />

        <Route path="/ViewOrderDetails" element={<ProtectedRoute allowedModules={['operation']}> <ViewOrderDetails /> </ProtectedRoute>} />


        <Route path="/Order-Data" element={<OrderData />} />

        <Route path="/Login-Customer" element={<LoginCustomer />} />
        <Route path="/CreatePasssword" element={<CreatePasssword />} />
        <Route path="/ConvertedLeadDataReport" element={<ProtectedRoute allowedModules={['operation']}> <ConvertedLeadDataReport /> </ProtectedRoute>} />
        <Route path="/CustomerNavbar" element={<ProtectedRoute allowedModules={['sales']}> <CustomerNavbar /> </ProtectedRoute>} />
        <Route path="/ExpenseList" element={<ProtectedRoute allowedModules={['operation', 'sales']}> <ExpenseList /> </ProtectedRoute>} />
        <Route path="/LeadExpenseList" element={<ProtectedRoute allowedModules={['operation', 'sales']}> <LeadExpenseList /> </ProtectedRoute>} />


        <Route path="/PetcrateList" element={<ProtectedRoute allowedModules={['master']}> <PetcrateList /> </ProtectedRoute>} />
        <Route path="/MicrochipListMain" element={<ProtectedRoute allowedModules={['master']}> <MicrochipListMain /> </ProtectedRoute>} />
        <Route path="/MicrochipQuantityMain" element={<ProtectedRoute allowedModules={['master']}> <MicrochipQuantityMain /> </ProtectedRoute>} />

        <Route path="/AddVendorDetails" element={<AddVendorDetails />} />
        <Route path="/AddVendorDetails_Admin" element={<ProtectedRoute allowedModules={['account']}><AddVendorDetails_Admin /></ProtectedRoute>} />
        <Route path="/DashboardTest" element={<OpsDashboard />} />

        <Route path="/AddFieldOpsExpense" element={<ProtectedRoute allowedModules={['operation']}> <AddOpsExpense /></ProtectedRoute>} />

        <Route path="/FieldOpsExpenseList" element={<ProtectedRoute allowedModules={['operation']}> <FieldOpsExpenseList /> </ProtectedRoute>} />
        <Route path="/InternationalRelocation" element={<ProtectedRoute allowedModules={['operation']}> <InternationalRelocation /> </ProtectedRoute>} />

        <Route path="/UserAvailabilityOps" element={<ProtectedRoute allowedModules={['operation']}> <UserAvailabilityOps /> </ProtectedRoute>} />
        <Route path="/SalesOrder" element={<ProtectedRoute allowedModules={['sales']}> <SalesOrder /> </ProtectedRoute>} />
        <Route path="/StaffListMainOperation" element={<ProtectedRoute allowedModules={['operation']}><StaffListMainOperation /></ProtectedRoute>} />
        <Route path="/ClientDocuments" element={<ClientDocuments />} />
        <Route path="/PettyCashHistorylist" element={<PettyCashHistorylist />} />


        <Route path="/DashboardOps" element={<ProtectedRoute allowedModules={['operation']}> <DashboardOps /> </ProtectedRoute>} />
        <Route path="/AssetsMaster" element={<ProtectedRoute allowedModules={['master']}> <AssetsMaster /> </ProtectedRoute>} />
        <Route path="/vendorDetailOverview" element={<ProtectedRoute allowedModules={['account']}> <VendorDetailsOverview /> </ProtectedRoute>} />
        <Route path="/leadTransfer" element={<ProtectedRoute allowedModules={["sales"]}><LeadTransfer /></ProtectedRoute>} />
        <Route path="/LeadDetail" element={<LeadDetail />} />
        <Route path="/PettyCashList" element={<ProtectedRoute allowedModules={['operation', 'account']}> <PettyCashList /> </ProtectedRoute>} />
        <Route path="/ViewPettyCashDetail" element={<ProtectedRoute allowedModules={['account']}> <ViewPettyCashDetail /> </ProtectedRoute>} />
        <Route path="/PettyCashDetail" element={<ProtectedRoute allowedModules={['operation', 'sales']}> <PettyCashDetail /> </ProtectedRoute>} />
        <Route path="/Test" element={<Test />} />
        <Route path="/ShipmentList" element={<ProtectedRoute allowedModules={['account']}> <ShipmentList /> </ProtectedRoute>} />
        <Route path="/ViewShipmentDetail" element={<ProtectedRoute allowedModules={['account']}> <ViewShipmentListDetail /> </ProtectedRoute>} />
        <Route path="/PaymentSuccess" element={<PaymentSuccess />} />
        <Route path="/PaymentFailed" element={<PaymentFailed />} />
        <Route path="/PaymentConfirmation" element={<ProtectedRoute allowedModules={['account']}> <PaymentConfirmation /> </ProtectedRoute>} />

        <Route path="/Invoice" element={<ProtectedRoute allowedModules={['account']}> <AccountsInvoice /> </ProtectedRoute>} />
        <Route path="/ShipmentExecutionSheet" element={<ProtectedRoute allowedModules={['account']}> <ShipmentExecutionSheet /> </ProtectedRoute>} />
        <Route path="/PaymentReceipt" element={<ProtectedRoute allowedModules={['account']}> <PaymentReceipt /> </ProtectedRoute>} />
        <Route path="/ProfitAndLoss" element={<ProtectedRoute allowedModules={['account']}> <ProfitAndLoss /> </ProtectedRoute>} />
        <Route path="/CustomerBalance" element={<ProtectedRoute allowedModules={['account']}> <CustomerBalance /> </ProtectedRoute>} />
        <Route path="/EmployeeExpenseDetail" element={<ProtectedRoute allowedModules={['account']}> <EmployeeExpenseDetail /> </ProtectedRoute>} />
        <Route path="/EmployeeExpenseDetailList" element={<ProtectedRoute allowedModules={['account']}> <EmployeeExpenseDetailList /> </ProtectedRoute>} />
        <Route path="/BalanceSheet" element={<ProtectedRoute allowedModules={['account']}> <BalanceSheet /> </ProtectedRoute>} />
        <Route path="/PaymentReceiptInfo" element={<ProtectedRoute allowedModules={['sales', 'master', 'account', 'operation', 'HR']}><PaymentReceiptInfo /></ProtectedRoute>} />
        <Route path="/PettyCashStatement" element={<ProtectedRoute allowedModules={['sales', 'master', 'account', 'operation', 'HR']}><PettyCashStatement /></ProtectedRoute>} />
        <Route path="/Bill" element={<AccountsBills />} />
        <Route path="/RelocationExpenseDetail" element={<ProtectedRoute allowedModules={['operation']}> <RelocationExpenseDetail /> </ProtectedRoute>} />
        <Route path="/titer-form" element={<TiterForm />} />
        <Route path="/bioBest" element={<Biobest />} />
        <Route path="/RffitLaboratories" element={<RffitLaboratoriesFrom />} />
        <Route path="/UpdateExpenseDetails" element={<UpdateExpenseDetails />} />
        <Route path="/AccountsDashboard" element={<ProtectedRoute allowedModules={['account']}> <AccountsDashboard /> </ProtectedRoute>} />
        <Route path="/CostCenterMaster" element={<ProtectedRoute allowedModules={["master", "account"]}> <CostCenterMaster /> </ProtectedRoute>} />
        <Route path="/SubCostCenterMaster" element={<ProtectedRoute allowedModules={["master", "account"]}> <SubCostCenterMaster /> </ProtectedRoute>} />
        <Route path="/ExpenseCategory" element={<ProtectedRoute allowedModules={["master", "account"]}> <ExpenseCategory /> </ProtectedRoute>} />
        <Route path="/ExpenseDescription" element={<ProtectedRoute allowedModules={["master", "account"]}> <ExpenseDescription /> </ProtectedRoute>} />
        <Route path="/TaskAssigned" element={<ProtectedRoute allowedModules={['sales', 'master', 'account', 'operation', 'HR']}><TaskAssigned /></ProtectedRoute>} />
        <Route path="/ViewTaskAssignedDetail" element={<ViewTaskAssignedDetail />} />
        <Route path="/RateCalculatorIndia" element={<ProtectedRoute allowedModules={["sales"]}><RateCalculatorIndia /></ProtectedRoute>} />
        <Route path="/EstimateIndia" element={<ProtectedRoute allowedModules={["sales"]}><EstimateIn /></ProtectedRoute>} />
        <Route path="/DutySlip" element={<ProtectedRoute allowedModules={["HR"]}>< DuttySlipBook /></ProtectedRoute>} />
        <Route path="/DutySlipDetails" element={<ProtectedRoute allowedModules={["HR"]}>< DutySlipDetails /></ProtectedRoute>} />
        <Route path="/CheckHistory" element={<ProtectedRoute allowedModules={["sales"]}>< CheckHistory /></ProtectedRoute>} />
        <Route path="/CheckHistoryDetails" element={<ProtectedRoute allowedModules={["sales"]}>< CheckHistoryDetails /> </ProtectedRoute>} />
        <Route path="/EstimateList" element={<ProtectedRoute allowedModules={["account"]}>< EstimateList /></ProtectedRoute>} />
        <Route path="/RateSheet" element={<ProtectedRoute allowedModules={["sales"]}>< Ratesheet /></ProtectedRoute>} />
        <Route path="/SalesSummary" element={<ProtectedRoute allowedModules={["account"]}>< SalesSummary /></ProtectedRoute>} />
        <Route path="/AccountsExpense" element={<AccountsExpense />} />
        <Route path="/PaymentReceipt1" element={<PaymentReceipt1 />} />
        <Route path="/fieldOpsPanel" element={<FieldMiniDrawer />} />
        <Route path="/pettycash" element={<PettyCashScreen />} />
        <Route path="/PettyCashRequest" element={<PettyCashRequest />} />
        <Route path="/PettyCashExpense" element={<PettyCashExpense />} />
        <Route path="/TripHistory" element={<TripHistory />} />
        <Route path="/trip-detail" element={<TripDetail />} />
        <Route path="/FieldDutySlip" element={<FieldDutySlip />} />
        <Route path="/duty-slip-detail" element={<FieldDutySlipDetail />} />
        <Route path="/ExpenseReport" element={<ProtectedRoute allowedModules={["account"]}>< ExpenseReport /></ProtectedRoute>} />
        <Route path="/ProfitLossReport" element={<ProtectedRoute allowedModules={["account"]}>< ProfitLossReport /></ProtectedRoute>} />
        <Route path="/IndirectExpense" element={<ProtectedRoute allowedModules={["account"]}>< IndirectExpense /></ProtectedRoute>} />
      </Routes>
    </>
  );
}

export default App;